<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <path id="패스_3986" data-name="패스 3986" fill="none" d="M0,0H24V24H0Z" />
    <g id="그룹_9133" data-name="그룹 9133" transform="translate(-308 -1093)">
      <path
        id="admin_panel_settings_FILL1_wght400_GRAD0_opsz24"
        fill="#21bf54"
        d="M17,22a4.993,4.993,0,0,1-5-5,4.993,4.993,0,0,1,5-5,4.992,4.992,0,0,1,5,5,4.992,4.992,0,0,1-5,5Z"
        transform="translate(308 1093)"
      />
      <path
        id="admin_panel_settings_FILL1_wght400_GRAD0_opsz24-2"
        data-name="admin_panel_settings_FILL1_wght400_GRAD0_opsz24"
        fill="#087ef7"
        d="M12,22a9.96,9.96,0,0,1-5.737-3.988A11.48,11.48,0,0,1,4,11.1V5l8-3,8,3v5.675a6.159,6.159,0,0,0-1.462-.5A7.32,7.32,0,0,0,17,10a7,7,0,0,0-7,7,6.5,6.5,0,0,0,.588,2.8,7.909,7.909,0,0,0,1.487,2.175.048.048,0,0,0-.037.013A.054.054,0,0,1,12,22Z"
        transform="translate(307 1093)"
      />
      <path
        id="admin_panel_settings_FILL1_wght400_GRAD0_opsz24-3"
        data-name="admin_panel_settings_FILL1_wght400_GRAD0_opsz24"
        fill="#ffc304"
        d="M17,20a2.873,2.873,0,0,0,1.425-.363,2.987,2.987,0,0,0,1.05-.962,4.892,4.892,0,0,0-1.175-.5,4.916,4.916,0,0,0-2.6,0,4.892,4.892,0,0,0-1.175.5,2.987,2.987,0,0,0,1.05.962A2.873,2.873,0,0,0,17,20Zm0-3a1.5,1.5,0,1,0-1.062-.438A1.444,1.444,0,0,0,17,17Z"
        transform="translate(308 1093)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
